<template>
  <div class="grid">
    <GridItem
      :prevId="prevId(index)"
      :nextId="nextId(index)"
      :item="item"
      :index="index"
      :pageSlug="pageSlug"
      v-for="(item, index) in items"
      :key="item.id"
    />
  </div>
</template>

<script>
import GridItem from "./Contact/GridItem";

export default {
  name: "Grid",
  components: { GridItem },
  props: {
    items: Array,
    pageSlug: String,
  },
  methods: {
    prevId(index) {
      if (index == 0) {
        return null;
      } else {
        return this.items[index - 1].id;
      }
    },
    nextId(index) {
      if (index == this.items.length - 1) {
        return null;
      } else {
        return this.items[index + 1].id;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

@media screen and (max-width: 960px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
